import axiosIns from '../../../xaxios';
import { obtenerUrl } from '../utils';

const get = async ({ params }) => {
  return await axiosIns.get(obtenerUrl('clasificadores'), { params });
};

const store = async (data) => {
  return await axiosIns.post(obtenerUrl('clasificadores'), data);
};

const update = async (id, data) => {
  return await axiosIns.put(obtenerUrl(`clasificadores/${id}`), data);
};

const destroy = async (id) => {
  return await axiosIns.delete(obtenerUrl(`clasificadores/${id}`));
};

const getTipoPartida = async (tipo_partida) => {
  return await axiosIns.get(obtenerUrl('clasificadores/subclasificadores'), { params: { tipo_partida } });
};

const findAllFiltros = async (params) => {
  return await axiosIns.get(obtenerUrl('clasificadores/filtros'), { params });
};

const importar = async (data) => {
  return await axiosIns.post(obtenerUrl('clasificadores/importar'), data);
};

export default {
  get,
  store,
  update,
  destroy,
  getTipoPartida,
  findAllFiltros,
  importar,
};
